export default __webpack_public_path__ + "static/Montserrat-Medium-3a0917345468c959207a35a358557a85.ttf";